<div class="width-100" [ngClass]="{'slidebar-container': showInput}">
    <ng-container *ngIf="rangeMin<rangeMax; else rangeNotValid">
        <twc-slider class="width-100" [ngClass]="{'hide-ranges': data.isLogarithmic || data.showRanges === false}"
            [label]="data.label ? (data.label | translate): null" [min]="rangeMin" [max]="rangeMax" [step]="stepSlider"
            [disabled]="disabled" [showValue]="false" [(ngModel)]="valueSlider" (input)="changeValueSlider($event)">
        </twc-slider>

        <input *ngIf="showInput" class="twc-input twc-mt-4 text-align-right" [(ngModel)]="inputValue"
            [disabled]="disabled" [readonly]="readonly" [step]="data.step" type="number" (change)="changeValueInput()">
    </ng-container>
    <ng-template #rangeNotValid>
        <label class="twc-body"> {{data.label ?? '' | translate}}: {{inputValue}} </label>
    </ng-template>
</div>